/**
 * 主页模块
 */
export default {
    namespaced: true,
    state: {
        // 这里放全局参数
        menuActive: 0, // 选中菜单下标
        menuJgActive: 1, // 选中机构菜单下标
        menus: [], // 菜单内容
        jgMenus: [],//机构菜单
        menuStyle: 0 ,// 使用的菜单样式
        selInputType: 0, //0显示跳转页面的搜索框   1显示当前页面搜索的搜索框
        societyLogoUrl: null ,//机构logo地址
		societyPhone: null,//机构电话
        showMenuType: 0,//0显示平台头部按钮  1显示机构头部按钮
        commonSocietyId: null,//机构id，记录当前游客所处机构首页的  机构id
        commonSocietyName: null,//机构name，记录当前游客所处机构首页的  机构name
        commonTopName: "",//获取上方背景图上显示的名称：公司名，或机构名
        commonTopSlogan: "",//获取上方背景图上显示的宣传语
        commonTopNameFontSize: "font-size: 36px;",//头部显示公司名称字体大小
    },
    getters: {
        // 这里放get方法 this.$store.getters['home/getMenus']
        getMenus() { // 获取系统菜单
            return ['首页', '找厂商', '案例展示','协会频道','关于平台']
        },
        getJgMenus() { // 获取系统菜单
            // return ['平台首页','机构首页', '找合作', '供需信息', '文章资讯']//网格宣传下版上
            return ['协会首页','协会简介', '文章资讯', '会员企业', '会员案例', '返回平台']//网格宣传下版上
        },
        getMenuActive: state => state.menuActive || 0, // 获取当前菜单选中下表
        getMenuJgActive: state => state.menuJgActive || 0, // 获取当前机构菜单选中下表
        getMenuStyle: state => state.menuStyle || 0, // 获取使用菜单的样式
        getSelInputType: state => state.selInputType || 0, // 获取显示搜索框类型
        getSocietyLogoUrl: state => state.societyLogoUrl || null,//获取机构logo
		getSocietyPhone: state => state.societyPhone || null,//获取机构电话
        getShowMenuType: state => state.showMenuType || 0,//获取显示头部菜单类型，0显示平台菜单   1显示机构菜单
        getCommonSocietyId: state => state.commonSocietyId || null, //获取公共机构id
        getCommonSocietyName: state => state.commonSocietyName || null, //获取公共机构name
        getCommonTopName:  state => state.commonTopName || "",//获取上方背景图上显示的名称：公司名，或机构名
        getCommonTopSlogan: state => state.commonTopSlogan || "",//获取上方背景图上显示的宣传语
        getCommonTopNameFontSize: state => state.commonTopNameFontSize || "font-size: 36px;"////头部显示公司名称字体大小
    },
    mutations: {
        // 这里是set方法  this.$store.commit('setDemoValue', value);
        setMenuActive(state, menuActive) { // 设置当前菜单选中
            state.menuActive = menuActive;
        },
        setMenuJgActive(state, menuJgActive) { // 设置当前机构首页菜单选中
            state.menuJgActive = menuJgActive;
        },
        setMenuStyle(state, menuStyle) { // 设置当前菜单样式
            state.menuStyle = menuStyle;
        },
        setSelInputType(state,selInputType){
            state.selInputType = selInputType;
        },
        setSocietyLogoUrl(state,societyLogoUrl){
            state.societyLogoUrl = societyLogoUrl;
        },
		setSocietyPhone(state,societyPhone){
            state.societyPhone = societyPhone;
        },
        setShowMenuType(state,showMenuType){
            state.showMenuType = showMenuType;
        },
        setCommonSocietyId(state,commonSocietyId){
            state.commonSocietyId = commonSocietyId;
        },
        setCommonSocietyName(state,commonSocietyName){
            state.commonSocietyName = commonSocietyName;
        },
        setCommonTopName(state,commonTopName){
            // 分辨率控制字体大小
            if(window.screen.width <= 1367 && commonTopName.length > 26){
                state.commonTopNameFontSize ="font-size: 30px;";
            }else{
                state.commonTopNameFontSize ="font-size: 36px;";
            }
            state.commonTopName = commonTopName;
        },
        setCommonTopSlogan(state,commonTopSlogan){
            state.commonTopSlogan = commonTopSlogan;
        },
        setCommonTopNameFontSize(state,commonTopNameFontSize){
            state.commonTopNameFontSize = commonTopNameFontSize;
        }

    },
    actions: {
        fnGoToPage({ commit }, data) { // 跳转页面
            // 跳转页面
            var path = '/home'
            var style = 1
            switch (parseInt(data)) {
                case 0: // 首页
                    path = '/home'
                    style = 0
                    break;
                case 1: // 找合作
                    path = '/companyInfoList'
                    break;
                case 2: // 案例
                    path = '/caseSearch';
                    break;
                case 3: // 协会列表
                   path = "/grid";
                    break;
                case 4: // 关于平台
                    path = "/about";
                    break;
            }
            commit('setMenuActive', data)
            commit('setMenuStyle', style)
            commit('setShowMenuType', 0)
            return path
        },

        fnGoToJgPage({ commit }, data) { // 跳转页面
            // 跳转页面
            var path = '/home'
            var style = 5
            var menuType = 1
            switch (parseInt(data)) {
                case 0: // 协会首页
                    path = '/societyIndex'
                    // style = 5
                    break;
                case 1: // 协会简介
                    path = '/societyAbout'
                    // style = 5
                    break;
                case 2: // 文章资讯
                    path = '/societyArticleNews';
                    break;
                case 3: // 企业展示
                    path = '/companyInfoList'
                    break;
                case 4: // 案例展示
                    path = '/caseSearch';
                    break;
                case 5: // 返回平台首页
                    menuType = 0
                    commit('setCommonSocietyId', null)
                    commit('setCommonSocietyName', null)
                    commit('setMenuActive', 0)
                    window.localStorage.removeItem('societyId')
                    window.localStorage.removeItem('societyName')
                    window.localStorage.removeItem('logoImgUrl')
                    path = '/home'
                    style = 0
                    break;
            }
            commit('setMenuJgActive', data)
            commit('setMenuStyle', style)
            commit('setShowMenuType', menuType)//机构菜单1
            return path
        },

        fnGetMenuStyle({ commit }, data) { // 获取当前使用的菜单样式
            let menuStyle = -1
            switch(data){
                case '/index':
                case '/':
                    // 首页使用首页头样式
                    menuStyle = 0
                    commit('setMenuStyle',0)
                    break
                case '/search':
                case '/caseSearch':
                case '/about':
                    menuStyle = 1
                    commit('setMenuStyle',1)
                    break
                case '/login':
                case '/registe':
                case '/registeSuccess':
                case '/wxScan':
                case '/wxLoginBack':
                case '/wxLoginBackRegister':
                    // 登录注册相关页面使用登录头样式
                    menuStyle = 2
                    commit('setMenuStyle',2)
                    break
                case '/societyArticleNews':
               
                
                case '/demand':
                
                    menuStyle = 3
                    commit('setMenuStyle',3)
                    break
                case '/appPubMain':
                case '/appDetail':
                    menuStyle = 4
                    commit('setMenuStyle',3)
                    break
                // case '/societyIndex':
                //     menuStyle = 5
                //     commit('setMenuStyle',5)
                //     break
                case '/cdrConvert':
                    menuStyle = 6
                    commit('setMenuStyle',6)
                    break
                default:
                    menuStyle = 1
                    commit('setMenuStyle',1)
                    break
            }
            return menuStyle
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js